import type { UiStrings } from '../types'

const ptBR: UiStrings = {
  brand: 'Holecard EX',
  docTitleSuffix: 'Registro de processo',
  tagline: 'Registre seat · holes · board · linha — card de processo compartilhável',
  metaDescription:
    'Holecard EX — registro de processo de poker mobile. Registre seat, hole cards, board e ações por street em um card compartilhável.',
  stepsAria: 'Etapas',
  prev: 'Voltar',
  undo: 'Desfazer',
  next: 'Próximo',
  nextSummary: 'Ver resumo',
  privacyLink: 'Privacidade e anúncios',
  privacyTitle: 'Privacidade e anúncios',
  privacyHint: 'Rascunho para revisão do AdSense. Revise e atualize antes da produção.',
  privacyBack: 'Voltar ao app',
  privacyCollectTitle: '1. Informações que coletamos',
  privacyCollectBody:
    'O Holecard EX atualmente monta rascunhos de revisão só no navegador. Sem login; dados da mão não são enviados a um servidor. Rascunhos podem ficar temporariamente no sessionStorage desta aba (esta política será atualizada se isso mudar).',
  privacyAdsTitle: '2. Cookies e anúncios',
  privacyAdsBody:
    'Redes de anúncios de terceiros como Google AdSense podem ser usadas. Anunciantes podem usar cookies ou identificadores de dispositivo para anúncios por interesse. Você pode controlar anúncios personalizados no navegador ou nas configurações do Google Ads.',
  privacyContactTitle: '3. Contato',
  privacyContactBody: 'Para dúvidas de política, abra uma issue no GitHub de holdcard-ex.com. E-mail do operador: TODO_OPERATOR_EMAIL na config do projeto.',
  langAria: 'Idioma',
  langCompactAria: 'Idioma (compacto)',
  koPathLink: '한국어',
  koPathLinkAria: 'Versão em coreano (/ko)',
  enPathLink: 'English',
  enPathLinkAria: 'Versão em inglês (/)',
  setupTitle: 'Mesa',
  setupHint: 'Jogadores · stack · blinds — depois Assento → Mão → Linha',
  players: 'Jogadores',
  playersUnit: (n) => `${n}-max`,
  sb: 'SB',
  bb: 'BB',
  ante: 'Ante (opcional)',
  anteHint: 'Mesma unidade dos blinds',
  effectiveStack: 'Stack efetivo (BB, opcional)',
  potBb: 'Pote (BB, opcional)',
  metaOptionalHint: 'Deixe ante / stack eff / pote vazios para ocultá-los nos resumos',
  setupDetailsToggle: 'Jogadores · ante · eff · pot · fichas',
  setupBasicsHint: 'Padrão (6-max · 100bb) ok — Próximo ou pular',
  setupMetaSetChip: 'Ante · eff · pote definidos',
  stackUnit: 'Unidade do stack',
  stackUnitBb: 'BB',
  stackUnitChips: 'Fichas',
  stackChips: 'Stack (fichas)',
  stackBb: 'Stack (BB)',
  stackChipsUnit: 'fichas',
  positionTitle: 'Assento',
  seatQuestion: 'Onde você sentou?',
  settingsBack: 'Voltar',
  settingsSegAria: 'Ajustes da mesa (jogadores · blinds · stack)',
  lineSeatEditAria: 'Editar assento',
  lineHoleEditAria: 'Editar cartas',
  positionHint: (count, hint) => `${count}-max assentos${hint ? ` · ${hint}` : ''}`,
  tableVizAria: (n) => `Assentos mesa ${n}-max`,
  tableVizHeroBadge: 'você',
  tableVizHeroSeatAria: (seat) => `${seat} (você)`,
  tableVizDealer: 'D',
  tableVizDealerTitle: 'Botão do dealer',
  tableVizTapHint: 'Toque seu assento na mesa',
  tableVizListFallback: 'Listar assentos · códigos',
  tableVizBlindsAria: (v) => `Blinds ${v}`,
  tableVizPotPlaceholder: 'Pote',
  tableVizPotValue: (v) => `Pote ${v}`,
  tableVizPotAria: (v) => `Pote ${v}`,
  tableVizStackAria: (v) => `Stack ${v}`,
  tableVizEmptyMark: '—',
  tableVizEffHint: (v) => `Eff ${v}bb`,
  tableVizEffTitle: 'Stack efetivo (da mesa, não por assento)',
  tableVizStepDown: 'Diminuir',
  tableVizStepUp: 'Aumentar',
  tableVizEditDone: 'Pronto',
  tableVizInfoHint: 'Toque blinds, pote ou stack na mesa para editar',
  seatAbbrevHint: 'Abreviações de assento. Toque para o nome completo.',

  cardsTitle: 'Mão',
  cardsHint: 'Comece pelas suas cartas · oponentes em «Adicionar oponentes» · slot · naipe e valor · sem duplicatas',
  heroHolesGuide: (seat) => `Escolha as 2 hole cards de ${seat}.`,
  cardSlot1: 'Carta 1',
  cardSlot2: 'Carta 2',
  cardSlotSelect: 'Selecionar',
  seatsLabel: 'Assentos',
  knownHolesOptional: 'Hole cards de oponentes são opcionais (showdown / revisão — vazio OK)',
  holesBySeat: 'Hole cards · escolha um assento',
  seatVillain: (pos) => `Vilão ${pos}`,
  seatFilled: 'Definido',
  holesModeHeroOnly: 'Só minhas cartas',
  holesModeWithVillains: 'Adicionar oponentes',
  holesModeAria: 'Modo de entrada de hole cards',
  villainNudgeToast: 'Conhece a mão de um vilão? Toque BB / CO etc.',
  heroCardsDoneCta: 'Ir para a linha',
  heroCardsAddVillainsCta: 'Adicionar oponentes',
  suitPickerLabel: 'Naipe',
  rankPickerLabel: 'Valor',
  boardTitle: 'Board',
  boardHint: 'Quando chegar — pule se for só pré-flop',
  flop: 'Flop',
  turn: 'Turn',
  river: 'River',
  flopSlot: (i) => `F${i}`,
  actionsTitle: 'Linha',
  actionsHint: 'Linha de ações por street — fold / check / call / bet / raise / all-in',
  actorQuick: 'Ator rápido',
  actor: 'Ator',
  actorPlaceholder: 'Digite o nome',
  actorCustomToggle: 'Nome personalizado',
  actorRequired: 'Digite ou selecione um ator',
  action: 'Ação',
  sizeLabel: 'Tamanho',
  sizePlaceholder: 'ex.: 2.5bb',
  sizeRequired: 'Digite o tamanho para bet/raise',
  sizeCustomToggle: 'Personalizado',
  sizeOpenApprox: 'Open',
  sizePotApprox: 'Tamanho do pote',
  sizeOverbetApprox: 'Overbet',
  sizeJamApprox: 'Short / jam',
  sizeUnitBb: 'bb',
  sizeUnitPct: 'pot',
  snapHint: 'Encaixa nos stops · ± um passo',
  favoritesLabel: 'Favoritos',
  morePresets: 'Mais presets',
  presetsSizeLabel: 'Presets · tamanho',
  potSizeHintUnset: 'Defina o pote (BB) no setup para ver o tamanho em bb',
  clearOptional: 'Limpar',
  betRaiseHint: 'Bet: sem agressão prévia · Raise: enfrentando bet/raise',
  allinSizeHint: 'Tamanho all-in opcional',
  sizeActionHint: (potBit) => potBit ? `Bet=primeiro · Raise=vs bet · ${potBit}` : 'Bet=primeiro · Raise=vs bet',
  addAction: (street) => `Adicionar ação de ${street}`,
  updateAction: 'Atualizar',
  editAction: 'Editar',
  cancelEdit: 'Cancelar edição',
  noStreetActions: (street) => `Ainda sem ações de ${street}.`,
  delete: 'Excluir',
  moveUp: 'Cima',
  moveDown: 'Baixo',
  allActionsHint: (n) => `${n} ações no total · veja outras abas`,
  heroChip: (pos) => pos,
  seatOrderHu: 'HU: BTN age como SB · ordem BTN/SB → BB',
  seatOrder: (order) => `Ordem dos assentos: ${order}`,
  positionHintHuBtn: 'Botão HU (SB)',
  keepActorHint: 'Abas de street mantêm o ator (só tipo/tamanho reiniciam)',
  potQuickPrompt: 'Pote rápido (BB) — toque para definir e atualizar a dica',
  potQuickClear: 'Limpar pote',
  quickLinesLabel: 'Linhas rápidas',
  quickLinesHint: 'Modelos comuns — toque para adicionar',
  macroOpenThenCall: 'Open depois call',
  macroFoldToHero: (seat) => `Folds até ${seat}`,
  macroCbet33: 'C-bet ⅓ pot',
  quickLinesSwitchStreet: 'Mude de street para macros',
  macroOpenExists: 'Um open (raise) já está registrado',
  macroAlreadyLogged: 'Open e call já estão registrados',
  macroFoldToHeroNone: (seat) => `Sem folds iniciais (ou ${seat} age primeiro)`,
  macroFoldToHeroBlocked: 'Ação inicial já registrada — adicione folds manualmente',
  boardCtaFlop: 'Adicionar flop',
  boardCtaTurn: 'Adicionar turn',
  boardCtaRiver: 'Adicionar river',
  quickHand: 'Mão rápida',
  skipToCards: 'Ir para cartas',
  jumpToActions: 'Ir para a linha',
  skipBoardPreflop: 'Pular board — só pré-flop',
  boardSlotsToggle: 'Adicionar board',
  softStackAria: 'Mão até agora',
  softStackLine: 'Linha',
  softStackHoles: 'Holes',
  softStackBoard: 'Board',
  streetTabWithCount: (street, n) => `${street} · ${n}`,
  actionIndexLabel: (n, street) => `Ação ${n} · ${street}`,
  copyLinkTitle: 'Reabre esta mão no app',
  suitStickyHint: 'Naipe fixo · toque um naipe para mudar',
  suitStickyChip: (s) => `Naipe atual ${s}`,
  suitMruLabel: 'Recentes',
  summaryHint: 'Tire print do card de processo abaixo ou copie/compartilhe o texto',
  summaryHole: 'Hole cards',
  summaryBoard: 'Board',
  summaryActions: 'Ações',
  timelineProcess: 'Processo',
  timelineBoard: (cards) => `Board ${cards}`,
  processMoreSummary: 'Mais processo',
  linePeekSummary: 'Linha até agora',
  takeawayLabel: 'Takeaway',
  takeawayPlaceholder: 'Só posição + linha — ex. BTN raise, BB call, flop check',
  takeawayHint: 'Uma linha de processo — só seat + linha',
  takeawayNudge: 'Nota do processo (opcional)\u00a0· assento\u00a0· linha',
  takeawayInLinkFact: 'A nota de processo está no link',
  shareSecondarySummary: 'Nota · oponentes (opcional)',
  shareSecondaryInvite: 'Deixe uma linha de processo (opcional)',
  shareMoreSummary: 'Outras formas de partilhar',
  lineDraftSummary: 'Ator · tamanho',
  explainModeLabel: 'Explicar',
  explainModeAria: 'Modo explicação — mostrar dicas',
  reviewScopeLabel: 'Revisar até',
  reviewScopePreflop: 'Pré-flop',
  reviewScopeFlop: 'Flop',
  reviewScopeRiver: 'River',
  reviewScopeAria: 'Alcance da revisão — recolhe streets seguintes (não apaga)',
  shareProcessHu: 'Heads-up',
  shareProcessMultiway: 'Multiway',
  shareReviewedLabel: 'Revisado',
  summaryCopyLabel: 'Colar no chat — legível + Pro',
  summaryProLabel: 'Notação Pro',
  emptyDash: '—',
  copyBoth: 'Compartilhar no chat',
  copyHuman: 'Legível',
  copyPro: 'Notação Pro',
  copied: 'Copiado ✓',
  copiedToast: 'Resumo copiado',
  screenshotHint: 'Capture = foto limpa · Link = reabrir a mão',
  captureMode: 'Captura',
  captureExit: 'Sair da captura',
  saveShareImage: 'Salvar imagem',
  shareImage: 'Compartilhar imagem',
  imageSaved: 'Salvo ✓',
  imageShared: 'Compartilhado ✓',
  imageSavedToast: 'Imagem salva',
  imageSharedToast: 'Imagem compartilhada',
  imageFailedToast: 'Não foi possível criar a imagem',
  shareText: 'Compartilhar texto',
  shared: 'Compartilhado ✓',
  copyLink: 'Copiar link',
  linkCopiedToast: 'Link da mão copiado',
  linkWithoutKnownHolesToast: 'Link copiado sem hole cards de vilões (longo demais)',
  linkTooLongToast: 'Mão grande demais para um link',
  sharedToast: 'Compartilhado',
  shareFailedToast: 'Falha ao compartilhar',
  newHand: 'Nova mão',
  receivedQuietRerecordCta: 'Registar o meu próprio processo',
  draftRestoredHint: 'Rascunho restaurado — continuar ou recomeçar?',
  draftContinue: 'Continuar',
  actorFoldedHint: 'Já foldou',
  summaryHeading: '[Resumo Holecard EX]',
  summaryPlayers: (n) => `Jogadores: ${n}-max`,
  summaryBlinds: (b) => `Blinds: ${b}`,
  summaryHero: (p) => `Assento: ${p}`,
  summaryStack: (s) => `Stack: ${s}`,
  summaryEff: (e) => `Stack eff: ${e} BB`,
  summaryPot: (p) => `Pote: ${p} BB`,
  summaryHoleLine: (h) => `Hole: ${h}`,
  summaryHolesHeader: 'Holes:',
  summaryKnownHoleLine: (label, cards) => `· ${label}: ${cards}`,
  summaryBoardLine: (b) => `Board: ${b}`,
  summaryActionsHeader: '── Ações ──',
  summaryFooter: '— Feito com Holecard EX',
  summaryProHeader: '── Notação Pro ──',
  tableLine: (n, blinds) => `${n}-max · ${blinds}`,
  errorBlinds: 'Blinds inválidos. BB deve ser > 0; SB ≥ 0 e ≤ BB.',
  hintFlopPartial: 'O flop costuma ter 3 cartas',
  hintNoActions: 'Sem ações também vale — «Concluir registro» compartilha o registro até aqui',
  missingFlopBoard: 'Há ações de flop, mas faltam cartas do flop',
  missingTurnBoard: 'Há ações de turn, mas falta a carta do turn',
  missingRiverBoard: 'Há ações de river, mas falta a carta do river',
  boardActionsMismatch: 'Ações em uma street cujo board está vazio',
  boardNeedFlop: 'Flop vazio — adicione cartas para uma revisão mais clara',
  boardNeedFlopPartial: 'Termine de inserir o flop',
  boardNeedTurn: 'Turn vazio — adicione para uma revisão mais clara',
  boardNeedRiver: 'River vazio — adicione para uma revisão mais clara',

  softGateTitle: 'Alguns campos ainda estão vazios',
  softGateBody: 'As hole cards ainda estão vazias. Adicione holes para registrar o processo, ou continue mesmo assim.',
  softGateFix: "Adicionar hole cards",
  softGateForceConfirm: "Compartilhar incompleto mesmo assim?",
  softGateMissingHoles: (seat) => `Hole cards de ${seat} (2)`,
  softGateMissingActions: "Pelo menos uma ação",
  softGateBodyLead: "Ainda falta:",
  incompleteBadge: "Incompleto",
  softGateContinue: 'Ver resumo mesmo assim',
  softGateShare: 'Compartilhar mesmo assim',
  softGateCopy: 'Copiar mesmo assim',
  softGateCancel: 'Voltar',
  pickerDisabled: 'Nenhum slot selecionado',
  step: {
    setup: 'Mesa',
    position: 'Assento',
    cards: 'Mão',
    board: 'Board',
    actions: 'Linha',
    summary: 'Compartilhar',
  },
  street: {
    preflop: 'Pré-flop',
    flop: 'Flop',
    turn: 'Turn',
    river: 'River',
  },
  actionType: {
    fold: 'Fold',
    check: 'Check',
    call: 'Call',
    bet: 'Bet',
    raise: 'Raise',
    allin: 'All-in',
  },
  suit: {
    s: 'Espadas',
    h: 'Copas',
    d: 'Ouros',
    c: 'Paus',
  },
  positionHintMap: {
    UTG: 'Under the gun',
    "UTG+1": 'UTG+1',
    MP: 'Middle',
    "MP+1": 'MP+1',
    HJ: 'Hijack',
    CO: 'Cutoff',
    BTN: 'Botão (dealer)',
    SB: 'Small blind',
    BB: 'Big blind',
  },
  progressAria: (current, total, label) =>
    `Etapa ${current} de ${total}: ${label}`,
  adArea: 'Área de anúncio',
  adTop: 'Anúncio superior',
  adBottom: 'Anúncio inferior',
  adPlaceholderHint: 'ID do AdSense não definido — placeholder até o deploy',
  // Softwise M10b: memory-order input
  endHere: "Terminar aqui",
  finishRecord: "Concluir registro",
  reviewAnte: (v) => `ante ${v}`,
  reviewEffStack: (v) => `efet. ${v}`,
  reviewBreakdownAria: 'Por street',
  reviewPlayers: (n) => `${n} jogadores`,
  // vocab-tags:start — screen-only poker vocabulary (review breakdown)
  reviewVocab: {
    trips: 'trips',
    paired: 'pareado',
    monotone: 'monotone',
    twoTone: 'two-tone',
    rainbow: 'rainbow',
    limp: 'limp',
    open: 'open',
    threeBet: '3-bet',
    fourBet: '4-bet',
    fiveBet: '5-bet',
    squeeze: 'squeeze',
    coldCall: 'cold call',
    checkRaise: 'check-raise',
    cBet: 'c-bet',
    donkBet: 'donk bet',
    probeBet: 'probe bet',
  },
  shareSavedMark: 'Salvo',
  // vocab-tags:end
  flowAskFlop: "Flop · 3 cartas",
  flowAskTurn: "Turn · 1 carta",
  flowAskRiver: "River · 1 carta",
  flowWhoActs: "Vez de",
  flowSizeCustom: "Outro",
  flowSizeConfirm: "OK",
  flowSizeLabel: "Tamanho (bb)",
  flowDone: "Linha registrada",
  flowRewind: "Refazer daqui",
  flowRewindCancel: "Cancelar",
  flowSeatUnrecorded: "não registrado",
  flowSeatNotInvolved: "não participou",
  flowMemoryCut: "Não lembro daqui pra frente",
  lineStripAria: "Linha registrada até agora",
  // Soft G: optional ending record (L1.5) — seat-subject, press-only, Quiet
  endingSummary: 'Final (opcional)',
  endingShownLabel: 'Cartas mostradas no showdown',
  endingPotLabel: 'Pote',
  endingCardsInput: 'Cartas',
  endingMuck: 'Não mostrou (muck)',
  endingUnknown: 'Desconhecido',
  endingPotTo: (seat) => `${seat} levou o pote`,
  endingSplit: 'Dividido',
  endingLineLabel: 'Final',
  endingShownCards: (seat, cards) => `${seat} mostrou ${cards}`,
  endingShownMuck: (seat) => `${seat} não mostrou (muck)`,
  endingShownUnknown: (seat) => `${seat} cartas desconhecidas`,
  endingPotSplit: 'Pote dividido',
  endingPotUnknown: 'Pote desconhecido',
  linkWithoutEndingToast: 'Link longo: o final foi omitido',
  linkWithoutTakeawayToast: 'Link longo: a nota de processo foi omitida',
  endingShownAria: (seat) => `${seat} cartas do showdown`,
}

export default ptBR
